import { Play, Eye } from "lucide-react"
import { Button } from "components/Button"

const ReadyToBeginCard = ({ onClick }) => {
  return (
    <div className={`card w-full bg-gray-50 border border-base-200 shadow-sm rounded-2xl overflow-hidden hover:shadow-md transition-all duration-300 border-l-4 border-l-blue-200`}>
      <div className="card-body p-6 flex flex-col items-center justify-center">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-100 text-blue-600 shrink-0">
          <Play size={22} />
        </div>

        <h1 className="text-sm font-semibold text-secondary-900 leading-snug">Ready to Begin</h1>
        <span className="text-xs text-secondary-500 ">Start the treatment plan review process</span>

        <Button
          title="Start Treatment Plan Review"
          onClick={onClick}
          variant="tertiary"
          icon={<Eye size={16} strokeWidth={3} />}
          className="mt-2 flex-1 sm:flex-none"
        />
      </div>
    </div>
  )
}

export default ReadyToBeginCard
